import React, { useCallback } from 'react';

import SumInformer from '../../modules/sum-informer/sum-informer';

import OperationHistoryItem from './operation-history-item/operation-history-item';

import './operations-history.scss';

interface OperationsHistoryProps {
  history: { sum: number; date: Date; period?: number }[];
  title?: string;
  showHeader?: boolean;
  accessSum?: number;
  dutySum?: number;
  onRefresh?: (val: number, period?: number) => void;
}

const OperationHistory: React.FC<OperationsHistoryProps> = ({
  history,
  showHeader,
  accessSum,
  dutySum,
  title,
  onRefresh,
}) => {
  const renderList = useCallback(
    () =>
      history.map((item) => (
        <li className="assets-history-module__item">
          <OperationHistoryItem
            sum={item.sum}
            date={item.date}
            period={item.period}
            onRefresh={onRefresh}
          />
        </li>
      )),
    [history]
  );

  return (
    <div className="assets-history-module">
      {showHeader && dutySum !== undefined && accessSum !== undefined ? (
        <div className="assets-history-module__header">
          <div className="assets-history-module__informers">
            <SumInformer sum={accessSum} title="Доступно для продажи:" lg />
            <SumInformer sum={dutySum} red title="Обязательста по займам:" lg />
          </div>
          {/* <IconBtn outlined sm title="Оплатить"/> */}
        </div>
      ) : null}
      <div className="assets-history-module__body">
        <div className="assets-history-module__title">{title ?? ''}</div>
        <ul className="assets-history-module__list">{renderList()}</ul>
      </div>
    </div>
  );
};

export default OperationHistory;
